export default __webpack_public_path__ + "static/the-tapping-solution-logo-b5edc697a5f434997365de38c56314ee.svg";